import { LoadableFactory, SaveableFactory } from '®shared/data';

import {
  UserResourceSubscriptionActionTypes,
  UserResourceSubscriptionActions,
} from './user-subscribed-resources.actions';
import { UserResourceSubscriptionState } from './user-subscribed-resources.state';

export function userResourceSubscriptionReducer(
  state: UserResourceSubscriptionState,
  action: UserResourceSubscriptionActions,
): UserResourceSubscriptionState {
  switch (action.type) {
    case UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION: {
      const { resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.loading(),
      };
    }
    case UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION_SUCCESS: {
      const { resourceId, isSubscribed } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.loaded(isSubscribed),
      };
    }
    case UserResourceSubscriptionActionTypes.FETCH_RESOURCE_SUBSCRIPTION_FAILED: {
      const { error, resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: LoadableFactory.errored<boolean>(error),
      };
    }
    case UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION: {
      const { resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: {
          data: true,
          ...SaveableFactory.saving(),
        },
      };
    }
    case UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION_SUCCESS: {
      const { resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: { data: true, ...SaveableFactory.reset() },
      };
    }
    case UserResourceSubscriptionActionTypes.UPDATE_RESOURCE_SUBSCRIPTION_FAILED: {
      const { error, resourceId } = action.payload;
      return {
        ...state,
        [resourceId]: SaveableFactory.errorSaving(error),
      };
    }
    default:
      return state;
  }
}
